<template>
  <v-card class="px-2">
    <v-card-title class="justify-end title-style" v-if="data.isWadiah === true">
      <h4>Input Dana Wadiah</h4>
    </v-card-title>
    <v-card-title
      class="justify-end title-style"
      v-else-if="data.isWadiah === false && selectedButton === 'debit'"
    >
      <h4>Input Pembayaran Debit</h4>
    </v-card-title>
    <v-card-title class="justify-end title-style" v-else>
      <h4>Input Pembayaran Tunai</h4>
    </v-card-title>
    <v-container class="container-scroll-input">
      <div class="container-wrapper mb-2">
        <div class="info-row">
          <label>No. RM</label>
          <span>{{ data.rm_number }}</span>
          <label>Nama</label>
          <span>
            <span>{{ data.name }} ({{ data.gender ? 'P' : 'L' }})</span>
          </span>
        </div>
        <div class="info-row">
          <label>Unit</label>
          <span>{{ data.unit }}</span>
          <label>Tipe Penjamin</label>
          <span>
            <span>{{ data.assurance }}</span>
          </span>
        </div>
      </div>
      <v-divider class="mb-2"></v-divider>
      <div class="container-wrapper body-row">
        <transition name="fade">
          <v-alert
            v-if="showAlert"
            dense
            outlined
            text
            type="error"
            style=" width: 100%; border-color: #EDEDED !important;"
          >
            <div
              style="font-size: 14px !important; color: #616161 !important; display: flex; justify-content: space-between; align-items: center;"
            >
              <span>
                Total yang harus dibayarkan telah berubah
              </span>
              <v-icon style="cursor: pointer;">mdi-close</v-icon>
            </div>
          </v-alert>
        </transition>
        <h4>Ringkasan Tagihan</h4>
        <v-row style="width: 400px; margin-top: 0 !important;">
          <v-col style="padding-block: 8px;" cols="4">
            <label>Total Tagihan</label>
          </v-col>
          <v-col style="padding-block: 8px;">
            <span>Rp {{ formatNumber(data.total_bill) }}</span>
          </v-col>
        </v-row>
        <v-row style="width: 400px; margin-top: 0 !important;">
          <v-col style="padding-block: 8px;" cols="4">
            <label>Total Wadiah</label>
          </v-col>
          <v-col style="padding-block: 8px;">
            <span>Rp {{ formatNumber(data.total_wadiah) }}</span>
          </v-col>
        </v-row>
        <v-row style="width: 400px; margin-top: 0 !important;">
          <v-col style="padding-block: 8px;" cols="4">
            <label>Sisa Tagihan</label>
          </v-col>
          <v-col style="padding-block: 8px;">
            <span>Rp {{ formatNumber(data.remaining_bill) }}</span>
          </v-col>
        </v-row>
        <v-row style="width: 400px; margin-top: 0 !important;">
          <v-col style="padding-block: 8px;" cols="4">
            <label>Sisa Saldo Wadiah</label>
          </v-col>
          <v-col style="padding-block: 8px;">
            <span
              >Rp
              {{
                Math.sign(data.total_wadiah - data.remaining_bill) === -1
                  ? 0
                  : formatNumber(data.total_wadiah - data.remaining_bill)
              }}</span
            >
          </v-col>
        </v-row>
        <v-row style="width: 400px; margin-top: 0 !important;" class="pb-3">
          <v-col style="padding-block: 8px;" cols="4">
            <label>Total Bayar</label>
          </v-col>
          <v-col style="padding-block: 8px;">
            <span>Rp {{ formatNumber(data.total_paid) }}</span>
          </v-col>
        </v-row>
      </div>
      <!-- <h4 class="text-left py-3">Ringkasan Tagihan</h4> -->
      <v-divider></v-divider>
      <h4 class="text-left py-3" v-if="data.isWadiah === true">
        Topup Saldo Wadiah
      </h4>
      <h4
        class="text-left py-3"
        style="color: #404040; font-size: 14px;"
        v-else
      >
        Input Pembayaran
      </h4>
      <div class="text-sm-left mt-2" v-if="selectedButton === 'debit'">
        <p class="caption font-weight-bold text-sm-left mb-2">Bank</p>
        <v-btn-toggle
          active-class="billing"
          :value="resource.bankList.value"
          v-model="inputDana.bank"
        >
          <v-btn
            v-for="(bank, index) in resource.bankList"
            :key="index"
            :value="bank.value"
            class="mb-2"
          >
            {{ bank.text }}
          </v-btn>
        </v-btn-toggle>
      </div>
      <v-row class="my-0">
        <v-col xs3 class="pr-2" v-if="selectedButton === 'debit'" cols="6">
          <v-text-field
            label="ID Kartu"
            placeholder="Masukkan ID Kartu (Opsional)"
            v-mask="'#### - #### - #### - ####'"
            v-model="inputDana.cardNumber"
            :error-messages="formValidation.cardNumber"
            hide-details="false"
          ></v-text-field>
        </v-col>
        <v-col xs3 class="py-0" cols="6">
          <v-currency-field
            v-model="totalInput"
            :autofocus="true"
            :error-messages="formValidation.totalPayment"
            prefix="Rp."
            outlined
            hide-details="false"
            class="remove-min-height"
          ></v-currency-field>
        </v-col>
      </v-row>
      <div class="text-left pt-3">
        <v-btn
          @click="saveInput"
          depressed
          class="text-none"
          color="primary"
          v-if="data.isWadiah === true"
        >
          Topup
        </v-btn>
        <div v-else style="color: #404040; font-size: 12px;">
          <label class="mr-4">Kembalian</label>
          <span style="font-weight: 500;">Rp {{ formatNumber(change) }}</span>
        </div>
      </div>
    </v-container>

    <v-card-actions>
      <v-btn @click="closeForm" class="text-none" text color="#1976D2">
        Kembali
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="data.isWadiah === true"
        outlined
        tile
        color="primary"
        class="text-none"
      >
        Print
      </v-btn>
      <v-btn
        style="color: white; border-radius: 4px; padding-inline: 12px; padding-block: 8px;"
        v-else
        tile
        depressed
        :disabled="selectedButton === 'debit' ? !inputDana.bank : false"
        class="text-none"
        color="#1976D2"
        @click="saveInput"
      >
        Simpan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Swal from 'sweetalert2';
import Constant from '@/const';
import AlertMixin from '@/mixin/alertMixin';

const axios = require('axios');

export default {
  name: 'PaymentInput',
  mixins: [AlertMixin],
  props: {
    data: Object,
    selectedButton: String,
  },
  data() {
    return {
      resource: {
        bankList: [
          { text: 'BCA', value: '014' },
          { text: 'Bank Mandiri', value: '008' },
          { text: 'Bank Mega', value: '426' },
          { text: 'BNI', value: '009' },
          { text: 'BRI', value: '002' },
          { text: 'Bank Permata', value: '013' },
          { text: 'CIMB Niaga', value: '022' },
        ],
      },
      formValidation: {
        cardNumber: null,
        totalPayment: null,
      },
      inputDana: {
        bank: '',
        cardNumber: '',
      },
      totalPayment: null,
      totalInput: 0,
      isCloseDetail: true,
      showAlert: false,
    };
  },
  mounted() {
    this.total();
  },
  watch: {
    totalInput(val) {
      if (val !== '') {
        if (val[0] === '0') {
          const slice = val.slice(1);
          this.totalInput = slice;
        }
      } else {
        this.totalInput = 0;
      }
    },
  },
  computed: {
    change() {
      return Math.sign(parseInt(this.totalInput) - this.data.remaining_bill) ===
        -1
        ? 0
        : parseInt(this.totalInput) - this.data.remaining_bill;
    },
  },
  methods: {
    closeForm() {
      this.$emit('close-form');
    },
    saveInput() {
      const id_billing = this.data.id;
      if (this.data.isWadiah === true) {
        if (this.selectedButton === 'debit') {
          axios
            .post(Constant.apiUrl.concat(`/billing/pay-wadiah/${id_billing}`), {
              amount: parseInt(this.totalInput),
              isCash: false,
              card_number: this.inputDana.cardNumber,
              bank: '5fbf86a460045c812123d9af',
              timestamps: {
                created_by: this.$store.getters.userLoggedIn.id,
              },
            })
            .then(response => {
              if (response.status === 200) {
                this.closeForm();
                Swal.fire({
                  icon: 'success',
                  title: 'Topup Saldo berhasil',
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.totalInput = 0;
                this.inputDana = '';
              }
            })
            .catch(err => {
              this.showErrorAxios(err);
            });
        } else if (this.selectedButton === 'tunai') {
          axios
            .post(Constant.apiUrl.concat(`/billing/pay-wadiah/${id_billing}`), {
              amount: parseInt(this.totalInput),
              isCash: true,
              timestamps: {
                created_by: this.$store.getters.userLoggedIn.id,
              },
            })
            .then(response => {
              if (response.status === 200) {
                this.closeForm();
                Swal.fire({
                  icon: 'success',
                  title: 'Topup Saldo berhasil',
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.totalInput = 0;
              }
            })
            .catch(err => {
              this.showErrorAxios(err);
            });
        }
      } else {
        if (this.selectedButton === 'debit') {
          axios
            .post(
              Constant.apiUrl.concat(`/billing/pay-billing/${id_billing}`),
              {
                amount: parseInt(this.totalInput),
                isCash: false,
                detail: this.data.detail,
                total_price: parseInt(this.totalPayment),
                card_number: this.inputDana.cardNumber,
                bank: this.inputDana.bank,
                timestamps: {
                  created_by: this.$store.getters.userLoggedIn.id,
                },
              },
            )
            .then(response => {
              if (response.status === 200) {
                this.closeForm();
                Swal.fire({
                  icon: 'success',
                  title: 'Pembayaran berhasil',
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.inputDana = '';
                this.$emit('is-close-detail');
              }
            })
            .catch(err => {
              const { status, data } = err?.response;
              if (status === 409) {
                let message = '';
                let isCont = false;
                let title = '';
                if (data.code === 'BILLING_CHANGED') {
                  message =
                    'Data Tagihan yang akan anda simpan telah disesuaikan di Penyerahan Obat. Periksa data tagihan kembali';
                  isCont = true;
                  title = 'Terdapat Perubahan Data Tagihan';
                } else if (data.code === 'BILLING_DISCOUNT_INVALID') {
                  message =
                    'Silakan periksa kembali sebelum melanjutkan pembayaran';
                  isCont = false;
                  title = 'Terdapat diskon yang tidak valid';
                }

                Swal.fire({
                  title: `<div style="font-family: Roboto, Serif; color: #404040; font-weight: 700; font-size: 20px; line-height: 30px;"><p>${title}</p></div>`,
                  iconHtml: `
                      <span
                        class="mdi mdi-alert-circle-outline"
                        style="
                          color: #F9A825;
                          border: 4px solid #fdeec8;
                          border-radius: 999px;
                          padding: 1.5rem;
                          display: inline-flex;
                          align-items: center;
                          justify-content: center;
                          width: 2rem;
                          height: 2rem;
                        ">
                      </span>`,
                  html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>${message}</p></div>`,
                  showCancelButton: true,
                  customClass: {
                    confirmButton: 'button-confirm',
                    cancelButton: 'button-cancel',
                  },
                  confirmButtonText: 'Lanjutkan Pembayaran',
                  cancelButtonText: isCont
                    ? 'Periksa Detail'
                    : 'Periksa Kembali',
                  showConfirmButton: isCont,
                  reverseButtons: true,
                }).then(async response => {
                  if (response.isConfirmed) {
                    await axios.post(
                      Constant.apiUrl.concat(
                        `/billing/pay-billing/${id_billing}`,
                      ),
                      {
                        amount: parseInt(this.totalInput),
                        isCash: false,
                        detail: this.data.detail,
                        total_price: parseInt(this.totalPayment),
                        card_number: this.inputDana.cardNumber,
                        bank: this.inputDana.bank,
                        timestamps: {
                          created_by: this.$store.getters.userLoggedIn.id,
                        },
                      },
                    );
                    this.$emit('refreshed');
                    this.change =
                      Math.sign(
                        parseInt(this.totalInput) - this.data.remaining_bill,
                      ) === -1
                        ? 0
                        : parseInt(this.totalInput) - this.data.remaining_bill;
                    this.showAlert = true;
                    setTimeout(() => {
                      this.showAlert = false;
                    }, 3000);
                  } else {
                    this.closeForm();
                  }
                });
                return;
              }
              this.showErrorAxios(err);
            });
        } else if (this.selectedButton === 'tunai') {
          axios
            .post(
              Constant.apiUrl.concat(`/billing/pay-billing/${id_billing}`),
              {
                amount: parseInt(this.totalInput),
                isCash: true,
                detail: this.data.detail,
                total_price: parseInt(this.data.total_bill),
                timestamps: {
                  created_by: this.$store.getters.userLoggedIn.id,
                },
              },
            )
            .then(response => {
              if (response.status === 200) {
                this.closeForm();
                Swal.fire({
                  icon: 'success',
                  title: 'Pembayaran berhasil',
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.totalInput = 0;
                this.$emit('is-close-detail');
              }
            })
            .catch(err => {
              const { status, data } = err?.response;
              if (status === 409) {
                let message = '';
                let isCont = false;
                let title = '';
                if (data.code === 'BILLING_CHANGED') {
                  message =
                    'Data Tagihan yang akan anda simpan telah disesuaikan di Penyerahan Obat. Periksa data tagihan kembali';
                  isCont = true;
                  title = 'Terdapat Perubahan Data Tagihan';
                } else if (data.code === 'BILLING_DISCOUNT_INVALID') {
                  message =
                    'Silakan periksa kembali sebelum melanjutkan pembayaran';
                  isCont = false;
                  title = 'Terdapat diskon yang tidak valid';
                }

                Swal.fire({
                  title: `<div style="font-family: Roboto, Serif; color: #404040; font-weight: 700; font-size: 20px; line-height: 30px;"><p>${title}</p></div>`,
                  iconHtml: `
                      <span
                        class="mdi mdi-alert-circle-outline"
                        style="
                          color: #F9A825;
                          border: 4px solid #fdeec8;
                          border-radius: 999px;
                          padding: 1.5rem;
                          display: inline-flex;
                          align-items: center;
                          justify-content: center;
                          width: 2rem;
                          height: 2rem;
                        ">
                      </span>`,
                  html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>${message}</p></div>`,
                  showCancelButton: true,
                  customClass: {
                    confirmButton: 'button-confirm',
                    cancelButton: 'button-cancel',
                  },
                  confirmButtonText: 'Lanjutkan Pembayaran',
                  cancelButtonText: isCont
                    ? 'Periksa Detail'
                    : 'Periksa Kembali',
                  showConfirmButton: isCont,
                  reverseButtons: true,
                }).then(async response => {
                  if (response.isConfirmed) {
                    this.$emit('refreshed');
                    this.change =
                      Math.sign(
                        parseInt(this.totalInput) - this.data.remaining_bill,
                      ) === -1
                        ? 0
                        : parseInt(this.totalInput) - this.data.remaining_bill;
                    this.showAlert = true;
                    setTimeout(() => {
                      this.showAlert = false;
                    }, 3000);
                  } else {
                    this.closeForm();
                  }
                });
                return;
              }
              this.showErrorAxios(err);
            });
        }
      }
    },
    formatNumber(num) {
      return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : 0;
    },
    total() {
      this.totalPayment =
        Math.sign(this.data.total_wadiah - this.data.remaining_bill) === -1
          ? Math.abs(this.data.total_wadiah - this.data.remaining_bill)
          : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-scroll-input {
  overflow-y: auto;
  height: auto;
  &::-webkit-scrollbar {
    width: 2px;
    background-color: rgb(163, 163, 163);
  }
  &::-webkit-scrollbar-thumb {
    width: 3px;
    background-color: black;
  }
}

.v-btn-toggle {
  box-shadow: none;
  border: none;
  flex-wrap: wrap;

  .v-btn {
    margin-right: 10px;
    border: 1px solid #a6adb4 !important;
    border-radius: 5px !important;
    box-shadow: none !important;
    background-color: white !important;
    padding: 0 20px !important;
    min-width: initial;
    text-transform: none;

    .v-btn__content {
      color: #a6adb4 !important;
    }

    &.v-btn--active {
      border-color: transparent;
      background: linear-gradient(180deg, #b3d1ff 0%, #99b4ff 100%);

      color: white !important;
    }

    &.bg-billing {
      background-color: linear-gradient(
        180deg,
        #b3d1ff 0%,
        #99b4ff 100%
      ) !important;
    }
  }
}

::v-deep .remove-min-height .v-input__slot {
  min-height: 0 !important;
}

.body-row {
  gap: 0 !important;
  text-align: start;
  color: #404040 !important;
  h4 {
    font-weight: 500;
    font-size: 14px;
  }
  label {
    font-weight: 500 !important;
    font-size: 12px !important;
  }
  span {
    font-weight: 400 !important;
    font-size: 12px !important;
  }
}

.container-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.75rem;
}

.info-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.info-row > *:nth-child(odd) {
  color: #9e9e9e;
  font-size: 12px;
  margin-right: 1rem;
}

.info-row > *:nth-child(even) {
  color: #404040;
  font-size: 12px;
  margin-right: 1.5rem;
}

.title-style {
  color: #404040 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
